import * as React from "react";

import { InfinitySpin } from "react-loader-spinner";
import { Container } from "react-bootstrap";
import { primary } from "../constants/colors";

const Loader = () => (
  <Container className="vh-100 d-flex flex-column flex-wrap-wrap justify-content-center align-items-center">
    <InfinitySpin width="200" color={primary} />
  </Container>
);

export default Loader;
